import { render, staticRenderFns } from "./WeeklyTransactionChart.vue?vue&type=template&id=a8e8783e&"
import script from "./WeeklyTransactionChart.vue?vue&type=script&lang=js&"
export * from "./WeeklyTransactionChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports